import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { navigationClient } from '../lib/navigation';
import { useSection } from './useSection';
import { logger } from '../lib/logger';

export const useReplacementImage = (itemImage?: string) => {
  const section = useSection();
  
  // Récupérer la navigation pour obtenir la configuration
  const { data: navigation } = useQuery({
    queryKey: ['navigation'],
    queryFn: () => navigationClient.getNavigation(),
    staleTime: 5 * 60 * 1000,
    cacheTime: 30 * 60 * 1000
  });

  // Obtenir l'image à afficher (null si use_img est false)
  const displayImage = useMemo(() => {
    // Trouver la section actuelle
    const currentSection = navigation?.find(navItem => {
      const itemSlug = navigationClient.generateSlug(navItem.names.fr);
      return (
        (navItem.type_rubrique === section.type_rubrique || 
         (section.type_rubrique === 'event-api' && navItem.type_rubrique === 'event-api')) && 
        itemSlug === navigationClient.generateSlug(section.names.fr)
      );
    });

    // Si use_img est false, ne pas afficher d'image
    if (currentSection?.use_img === false) {
      logger.debug('Images disabled for section', {
        category: 'Images',
        data: { 
          section: section.type_rubrique,
          sectionName: section.names.fr,
          useImg: currentSection.use_img
        }
      });
      return null;
    }

    // Si use_img est true ou non défini, utiliser l'image de l'item
    return itemImage || null;
  }, [itemImage, navigation, section]);

  return displayImage;
};